import { useMutation } from 'react-query';
import axios from 'axios';
import { commonHeaders } from '../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../context/AlertProvider';
import { LicenseAPI } from '../../constants/API';
import { queryClient } from '../../queryClient';
import { AlertType } from '../../types/enums';
// import { AlertType } from '../../components/InterceptorAlertMessage/InterceptorTypes';

type LicenseDataType = {
  key: string;
};

export const useAddLicense = (withCurrentLicenseInvalidate: boolean, onSuccess?: () => void) => {
  const context = useContext(AlertContext);

  const { mutate: addLicense, isLoading: isAddLicensePending } = useMutation({
    mutationFn: (data: LicenseDataType) => axios.post(LicenseAPI.addLicense, data, commonHeaders()),
    onSuccess: () => {
      if (withCurrentLicenseInvalidate) {
        queryClient.invalidateQueries({ queryKey: ['getCurrentLicenseData'] });
      }

      queryClient.invalidateQueries({ queryKey: ['getAllLicenses'] }).then(() => {
        context.setAlert({
          type: AlertType.Success,
          message: 'Лицензия успешно добавлена'
        });

        if (onSuccess) {
          onSuccess();
        }
      });
    }
  });

  return { addLicense, isAddLicensePending };
};
